import { computed, get } from "@ember/object"
import PromiseProxyMixin from "@ember/object/promise-proxy-mixin"
import ObjectProxy from "@ember/object/proxy"
import _ from "lodash"
import { all } from "rsvp"

export default function hasManyCollectively(modelName, relationshipType, relationship) {
  return computed(`${modelName}.relationships.${relationship}.data.@each.id`, function () {
    const ObjectPromiseProxy = ObjectProxy.extend(PromiseProxyMixin)
    if (get(this, "store") === null)
      throw new Error(
        "You need to inject the store before using hasManyCollectively: " + this.toString()
      )

    let ids = _.reject(
      _.map(get(this, `${modelName}.relationships.${relationship}.data`), (r) => get(r, "id")),
      (id) => id === "" || id === null
    )

    return ObjectPromiseProxy.create({
      promise: all(_.map(ids, (id) => get(this, "store").find(relationshipType, id))),
    })
  })
}
